export default function ButtonEditIcon() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 15.6874H3.375C3.22582 15.6874 3.08274 15.6282 2.97725 15.5227C2.87176 15.4172 2.8125 15.2741 2.8125 15.1249V11.9829C2.8125 11.909 2.82705 11.8359 2.85532 11.7677C2.88359 11.6994 2.92502 11.6374 2.97725 11.5852L11.4148 3.14766C11.5202 3.04217 11.6633 2.98291 11.8125 2.98291C11.9617 2.98291 12.1048 3.04217 12.2102 3.14766L15.3523 6.28967C15.4577 6.39516 15.517 6.53823 15.517 6.68741C15.517 6.8366 15.4577 6.97967 15.3523 7.08516L6.75 15.6874ZM6.75 15.6874H15.1875M6.75 15.6874L2.84829 11.7857M9.5625 4.99991L13.5 8.93741"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
